import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss']
})
export class ProjectsComponent implements OnInit {
  projects = [];
  constructor() { }

  ngOnInit(): void {
    this.projects = [
      {
        title: "Try Jobs",
        image: "assets/images/projects/tryjobs.png",
        role: "Front-end Developer",
        domain: "Job Portal",
        link: "https://tryjobs.co",
        description: "Project is to provide an easy interface to the job seekers especially, those who are non-professional workers so that they find their job more easily, and to deliver the small and medium scale employers with an effective digital platform to post their jobs and to search for their candidates.",
        tech: "#Angular, #CSS, #Bootstrap, #Aws, #CDN, #S3, #Linux, #Cron, #Apache, #Nginx"
      },
      {
        title: "Oor Cabs",
        image: "assets/images/projects/oorcabs.png",
        role: "Full Stack Developer",
        domain: "Cab Service",
        description: "Mobile and Admin app for cab service like OLA & Uber",
        tech: "#Angular, #CSS, #Bootstrap, #Laravel, #Node, #Mongodb, #Mongoose, #Mqtt, #Mosquitto, #Aws, #Linux, #Cron, #CDN, #S3, #LetsEncrypt"
      },
      {
        title: "Fast Track",
        image: "assets/images/projects/fasttrack.png",
        role: "Back-end Developer",
        domain: "Cab Service",
        link: "https://play.google.com/store/apps/details?id=com.stpl.fasttrackbooking1",
        description: "Mobile and Admin app for cab service like OLA & Uber",
        tech: "#PHP, #Nodejs, #CentOS, #Digital Ocean,#Socket.io"
      },
      {
        title: "Knowledge Checkers",
        image: "assets/images/projects/knowledgecheckers.png",
        role: "Full Stack Developer",
        domain: "Education",
        link: "http://knowledgecheckers.com",
        description: "Knowledgecheckers is a breakthrough educational technology providing a one-step solution to host your Flipped Classroom. It provides a unified platform to host your classes in a predetermined framework, as well as to conduct class polls to assess your students during the in-class-session.",
        tech: "#Single-Tenant, #Angular, #Nodejs, #Mysql, #Sequilize, #Aws, #Bootstrap, #SCSS, #Linux, #Nginx, #MQTT, #LetsEncrypt"
      },
      {
        title: "Sportiv",
        image: "assets/images/projects/sportiv.png",
        role: "Full Stack Developer",
        domain: "Sports",
        description: "Sportiv is the first-of-its-kind holistic platform to support sports professionals. It is the Go-To platform for sports players to aspire to achieve the level to keep track of their sports achievements, build an awesome sports profile, get peer updates, and seek opportunities/sponsorships.",
        tech: "#Angular, #Laravel, #Aws, #Bootstrap, #CSS, #Linux, #Nginx"
      },
      {
        title: "LeagueIv",
        image: "assets/images/projects/league.png",
        role: "Full Stack Developer",
        domain: "Sports",
        description: "Project is to provide an easy interface for the League Management system starting from registration, fixtures to end of result.",
        tech: "#Angular, #Laravel, #Aws, #Bootstrap, #CSS, #Linux, #Nginx"
      },
      {
        title: "LivingnMemories",
        image: "assets/images/projects/memories.png",
        role: "Full Stack Developer",
        domain: "Social",
        link: "http://d2g05gwowavp7b.cloudfront.net",
        description: "Photo collection app for to share memories about the person or about an event",
        tech: "#Angular, #Bootstrap, #SCSS, #Nodejs, #Mongodb, #Serverless, #Aws, #S3, #Lambda, #ApiGateway, #CDN"
      },
      {
        title: "Energy Management",
        image: "assets/images/projects/vipertech.png",
        role: "Back-end Developer",
        domain: "IOT",
        link: "http://www.vipertech.in",
        description: "Home appliances energy consumption, management and monitoring app",
        tech: "#Nodejs, #Mongodb, #Serverless, #Aws, #S3, #Lambda, #ApiGateway"
      }
    ]
  }

}
